import { jsx as _jsx } from "react/jsx-runtime";
import Slide from "@mui/material/Slide";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { forwardRef } from "react";
/**
 * Every dialog's entrance (theme `MuiDialog`): it slides up from the bottom
 * on a phone and in from the right from the `md` breakpoint, matching where
 * the theme docks the paper. Instant under reduced motion.
 */
export const DrawerTransition = forwardRef(function DrawerTransition(props, ref) {
    const theme = useTheme();
    const side = useMediaQuery(theme.breakpoints.up("md"));
    const still = useMediaQuery("(prefers-reduced-motion: reduce)");
    return (_jsx(Slide, { ref: ref, direction: side ? "left" : "up", ...props, ...(still ? { timeout: 0 } : {}) }));
});
//# sourceMappingURL=DrawerTransition.js.map